import React from 'react';
import clsx from 'clsx';
import styles from './Placeholder.module.css';
import BzmIcon from '../icons/BzmIcon';
import _ from 'lodash';

interface PlaceholderProps {
  icon: 'danger' | 'info';
  title: string;
  iconSize?: number;
  titleSize?: number;
  message?: string;
}
const Placeholder = (props: PlaceholderProps) => {
  return (
    <div className={clsx(styles.PlaceholderWrapper, 'd-flex justify-content-center align-items-center')}>
      <div className="text-center">
        <BzmIcon
          variant={'icon-bzm-' + props.icon}
          className={styles.PlaceholderIcon}
          size={props.iconSize ? props.iconSize : 140}
        />
        <h3 className="font-size-xjb mb-5" style={{ fontSize: props.titleSize ? props.titleSize : undefined }}>
          {props.title}
        </h3>
        {!_.isNil(props.message) && (
          <div className="p-2 w-100 bd-highlight text-center" style={{ maxWidth: '280px' }}>
            <p>{props.message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Placeholder;
